// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_8deed78","status":"_6d4f8d3"};